import { gql } from '@apollo/client';

export default gql`
  query meals($reference: String!, $segmentId: String!) {
    meals(reference: $reference, segmentId: $segmentId) {
      code
      name
    }
  }
`;
